import script from "./Button_work_AS.vue?vue&type=script&setup=true&lang=js"
export * from "./Button_work_AS.vue?vue&type=script&setup=true&lang=js"

import "./Button_work_AS.vue?vue&type=style&index=0&id=8be369c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be369c8"]])

export default __exports__